<template>
  <a id="webinarsBox" class="box" :href="webinarItemLink(item)">
    <div class="title">{{ item.title }}</div>
    <div
      class="auth-time-duration-wrapper"
      :class="{ shrinkSubtitleWidth: shrinkSubtitleWidth }"
    >
      <div class="author-time-wrapper">
        <div class="icon">
          <img :src="item.hosted_by.image" class="img-responsive" />
        </div>
        <div class="details">
          {{ item.hosted_by.name }} <span class="dot-separator">&#8226;</span>
          {{ formatDate(item.date) }}
        </div>
      </div>
      <div class="duration" v-if="currentlyAvailable && !narrowScreen">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
        >
          <defs></defs>
          <path
            class="a-duration"
            d="M7.458.562a6.9,6.9,0,1,0,6.9,6.9A6.894,6.894,0,0,0,7.458.562ZM9.045,10.3,6.593,8.514a.336.336,0,0,1-.136-.27V3.565a.335.335,0,0,1,.334-.334H8.125a.335.335,0,0,1,.334.334V7.394l1.765,1.284a.333.333,0,0,1,.072.467l-.784,1.079A.336.336,0,0,1,9.045,10.3Z"
            transform="translate(6.333 6.333)"
          />
          <rect class="b-duration" width="28" height="28" />
        </svg>
        <span>{{ videoLength }}</span>
      </div>
    </div>
    <img :src="item.image" class="poster" />
    <button class="book-now">{{ actionButtonText }}</button>
  </a>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "CardWebinars",
  data() {
    return {
      currentlyAvailable: false
    };
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapState(["lang", "webInfo"]),
    ...mapGetters(["t"]),
    actionButtonText: function() {
      const btnText = this.currentlyAvailable
        ? "Watch_now_CTA"
        : "Book_now_CTA";
      return this.t(btnText);
    },
    shrinkSubtitleWidth: function() {
      return this.item.hosted_by.name.length > 20;
    },
    narrowScreen() {
      return window.matchMedia("(max-width: 400px)").matches;
    },
    videoLength() {
      if (this.item.video) {
        const lengthInSeconds = this.item.video.length;
        const formatted = moment.utc(lengthInSeconds * 1000);
        if (lengthInSeconds <= 3600) {
          return formatted.format("mm:ss");
        } else {
          return formatted.format("HH:mm:ss");
        }
      } else {
        return "";
      }
    }
  },
  methods: {
    formatDate(date) {
      moment.locale(this.lang);
      const dateAsCETtz = moment(date + "+01:00"); //treat the hard coded time as if it is CET +1
      return dateAsCETtz.format("DD MMM, HH:mm");
    },
    webinarItemLink(item) {
      return `${this.webInfo.getFullHostWithProtocol()}/plus/webinars/${item.friendly_url}`; //relative redirect isn't possible. this component is sometime displayed as part of instruments page
    },
    dontShow(event) {
      event.target.style.display = "none";
    },
    updateAvailabiltyStatus() {
      const itemDate = moment(this.item.date);
      const today = moment();
      this.currentlyAvailable = itemDate > today ? false : true;
    }
  },
  created() {
    this.updateAvailabiltyStatus();
  }
};
</script>

<style lang="scss" scoped>
#webinarsBox {
  .title {
    margin-bottom: 0.3125rem;
    min-height: 3rem;
    font-size: 1.125rem;
  }

  .details {
    position: relative;
    display: flex;
    align-items: center;
    font-size: 0.75rem;
    color: #9e9e9e;

    .dot-separator {
      margin-left: 5px;
      margin-right: 5px;
    }
  }

  .poster {
    //width: 18.63rem;
    width: 100%;
    height: 192px;
    align-self: baseline;
  }

  .auth-time-duration-wrapper {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.625rem;
    min-height: 29px; //the height of the clock svg

    .author-time-wrapper {
      display: flex;
    }
    .duration {
      span {
        font-size: 0.75rem;
        color: #9e9e9e;
      }
      .a-duration {
        fill: #9e9e9e;
      }

      .b-duration {
        fill: none;
      }
    }

    &.shrinkSubtitleWidth {
      svg {
        margin-left: -4px;
        margin-right: -4px;
      }
    }
  }

  .icon {
    //margin-top:0.75rem;
    display: flex;
    align-items: center;
    margin-right: 2px;

    img {
      width: 1.125rem;
      height: 1.125rem;
      margin-right: 3.5px;
      object-fit: cover;
      border-radius: 50%;
    }
  }

  .img-or-video {
    position: relative;
    width: 18.5rem;
    height: 13.75rem;
    margin: 0.75rem auto 0;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
  .book-now {
    min-width: 123px;
    padding-right: 1rem;
    padding-left: 1rem;
    height: 32px;
    font-size: 1rem;
    color: #424242;
    margin: 1.25rem auto 0.625rem auto;
    background: transparent;
    border: 1px solid #7a7c7c;
    border-radius: 3px;
    color: #424242;
    font-weight: 500;
    &:hover {
      background-color: #1c79be;
      color: #ffffff;
      border: none;
    }
    &:focus {
      outline: none;
    }
  }
}
.ar {
  #webinarsBox {
    .icon {
      margin: 0 0 0 2px;
      img {
        margin: 0 0 0 3.5px;
      }
    }
  }
}
@media only screen and (max-width: 768px) {
  #webinarsBox {
    .title {
      min-height: auto;
    }
    .icon {
      img {
        //margin-right: 8px; //required by the design, but it breaks things
        margin-right: 4px;
      }
    }
    .poster {
      height: 166px;
    }
  }
}
</style>
